/** URL-safe slug from arbitrary text (strips diacritics, collapses non-alnum). */
export function slugify(input) {
    return input
        .normalize('NFKD')
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/(^-|-$)/g, '');
}
export function mapManatalJob(raw) {
    const title = raw.position_name ?? '';
    const salary = raw.is_salary_visible ? (raw.salary_max ?? raw.salary_min ?? null) : null;
    return {
        id: String(raw.id),
        title,
        content: raw.description ?? '',
        workFromHome: Boolean(raw.is_remote),
        salary: salary ?? null,
        salaryMin: raw.is_salary_visible ? (raw.salary_min ?? null) : null,
        currency: raw.currency ?? null,
        contractDetails: raw.contract_details ?? null,
        locationDisplay: raw.location_display ?? null,
        slug: `${slugify(title)}-${raw.id}`,
    };
}
/** Build the Manatal endpoint URLs for a given career-page slug + base. */
export function manatalUrls(base, careerSlug) {
    const root = `${base.replace(/\/$/, '')}/${careerSlug}`;
    return {
        jobsList: `${root}/jobs/?page_size=100`,
        job: (id) => `${root}/jobs/${id}`,
        applicationForm: (id) => `${root}/jobs/${id}/application-form/`,
        apply: (id) => `${root}/jobs/${id}/apply/`,
    };
}
//# sourceMappingURL=manatal.js.map